import React from 'react';
import Close from "../../icons/close.svg";
import Logo from "../../icons/logo-red.svg";
import './SubscribersPopup.styles.scss';

function SubscribersPopup({ close }) {
    return (
        <div className="subscribers-popup">
            <button
                className="subscribers-popup__close"
                onClick={close}
            >
                <Close />
            </button>
            <div className="subscribers-popup__logo"><Logo /></div>
            <div className="subscribers-popup__title">This feature requires <br/> enhanced access.</div>
            <a target="_blank" href='https://www.ifmaworld.com/consumerfoodjourney' className="subscribers-popup__link">
                Learn more
            </a>
        </div>
    );
}

export default SubscribersPopup;